import {ChangeDetectionStrategy, Component, input, signal} from '@angular/core';
import {sign} from "node:crypto";
import {Severity} from "../../enum-to-tag";
import {Tag} from "primeng/tag";
import {CopyButtonComponent} from "../copy-button/copy-button.component";

@Component({
  selector: 'app-labeled',
  imports: [
    Tag,
    CopyButtonComponent
  ],
  templateUrl: './labeled.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LabeledComponent<T extends string> {
  public readonly label = input.required<string>();
  public readonly value = input.required<T | undefined | null>();
  public readonly copy = input<boolean>(false);
  public readonly tagFunction = input<(value: T) => Severity>();
}
